
import { Facebook, Instagram, Linkedin, Youtube } from "lucide-react";

const FooterSocialLinks = () => {
  return (
    <div className="mt-6 md:mt-8">
      <h3 className="text-lg font-semibold mb-4 text-white flex items-center justify-center md:justify-start">
        <svg className="h-5 w-5 text-yellow-400 mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15.5799 12.0371C16.0398 12.4971 16.0398 13.2571 15.5799 13.7171L11.9999 17.3071C11.5399 17.7671 10.7799 17.7671 10.3199 17.3071C9.85993 16.8471 9.85993 16.0871 10.3199 15.6271L12.4399 13.5071L4.99993 13.5071C4.31993 13.5071 3.74993 12.9371 3.74993 12.2571C3.74993 11.5771 4.31993 11.0071 4.99993 11.0071L12.4399 11.0071L10.3199 8.88713C9.85993 8.42713 9.85993 7.66713 10.3199 7.20713C10.7799 6.74713 11.5399 6.74713 11.9999 7.20713L15.5799 10.7971C15.8099 11.0271 15.9299 11.3471 15.9299 11.6571C15.9299 11.8271 15.8799 11.9471 15.8299 12.0871L15.5799 12.0371Z" fill="currentColor"/>
          <path d="M19.25 12C19.25 16.0041 16.0041 19.25 12 19.25C7.99594 19.25 4.75 16.0041 4.75 12C4.75 7.99594 7.99594 4.75 12 4.75C16.0041 4.75 19.25 7.99594 19.25 12Z" stroke="currentColor" strokeWidth="1.5"/>
        </svg>
        Seuraa meitä
      </h3>
      <div className="flex justify-center md:justify-start space-x-4 md:space-x-3 lg:space-x-4 mt-3 md:mt-4">
        <a 
          href="https://www.facebook.com/lainasampo.fi" 
          target="_blank" 
          rel="noopener noreferrer"
          className="text-blue-200 hover:text-white transition-colors bg-blue-700 hover:bg-blue-600 p-2 rounded-full hover:scale-110 transform duration-200"
          aria-label="Facebook"
        >
          <Facebook size={20} />
        </a>
        <a 
          href="https://www.instagram.com/lainasampo.fi" 
          target="_blank" 
          rel="noopener noreferrer"
          className="text-blue-200 hover:text-white transition-colors bg-blue-700 hover:bg-blue-600 p-2 rounded-full hover:scale-110 transform duration-200"
          aria-label="Instagram"
        >
          <Instagram size={20} />
        </a>
        <a 
          href="https://www.tiktok.com/@lainasampo.fi" 
          target="_blank" 
          rel="noopener noreferrer"
          className="text-blue-200 hover:text-white transition-colors bg-blue-700 hover:bg-blue-600 p-2 rounded-full hover:scale-110 transform duration-200"
          aria-label="TikTok"
        >
          <svg 
            width="20" 
            height="20" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
            className="lucide lucide-icon"
          >
            <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" />
          </svg>
        </a>
        <a 
          href="https://www.lainasampo.fi" 
          target="_blank" 
          rel="noopener noreferrer"
          className="text-blue-200 hover:text-white transition-colors bg-blue-700 hover:bg-blue-600 p-2 rounded-full hover:scale-110 transform duration-200"
          aria-label="Kotisivu"
        >
          <svg 
            width="20" 
            height="20" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            strokeWidth="2" 
            strokeLinecap="round" 
            strokeLinejoin="round"
            className="lucide lucide-icon"
          >
            <path d="M3 12a9 9 0 1 0 18 0 9 9 0 0 0-18 0z" />
            <path d="M3 12h18" />
            <path d="M12 3a15 15 0 0 1 3 19.5" />
            <path d="M12 3a15 15 0 0 0-3 19.5" />
          </svg>
        </a>
      </div>
    </div>
  );
};

export default FooterSocialLinks;
